var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "icon icon-tabler icons-tabler-outline icon-tabler-brand-docker",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 12.54c-1.804 -.345 -2.701 -1.08 -3.523 -2.94c-.487 .696 -1.102 1.568 -.92 2.4c.028 .238 -.32 1 -.557 1h-14c0 5.208 3.164 7 6.196 7c4.124 .022 7.828 -1.376 9.854 -5c1.146 -.101 2.296 -1.505 2.95 -2.46z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 10h3v3h-3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10h3v3h-3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11 10h3v3h-3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8 7h3v3h-3z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11 7h3v3h-3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11 4h3v3h-3z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.571 18c1.5 0 2.047 -.074 2.958 -.78"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10 16l0 .01"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocker);
export default __webpack_public_path__ + "static/media/docker.cc29258545fe81d19ad9846b45beeff4.svg";
export { ForwardRef as ReactComponent };